import api from './index'

export function geoConfigsSave(payload, shop) {
  return api.post('geoconfig/', payload, { params: { shop } })
}
